import dayjs from 'dayjs'
import { useEffect } from 'react'
import { useAppSelector } from 'store/useStoreHook'
import 'dayjs/locale/th'
import 'dayjs/locale/en'

const useDateLocale = () => {
    const { language } = useAppSelector((state) => state.operation.data)

    useEffect(() => {
        if (language) {
            dayjs.locale(language)
        }
    }, [language])
}

export default useDateLocale
